import { render, staticRenderFns } from "./AppWatermark.vue?vue&type=template&id=8bcda526&scoped=true"
import script from "./AppWatermark.vue?vue&type=script&lang=js"
export * from "./AppWatermark.vue?vue&type=script&lang=js"
import style0 from "./AppWatermark.vue?vue&type=style&index=0&id=8bcda526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcda526",
  null
  
)

export default component.exports